import http from '../../../../api/http';
import type { ConfiguracionCuenta } from '../types/configuracion';

const ENDPOINTS = {
  BASE: '/contabilidad/configuracion',
};

export class ConfiguracionCuentaService {
  public static async getByEjercicio(idEjercicio: number): Promise<ConfiguracionCuenta> {
    const response = await http.get(`${ENDPOINTS.BASE}/${idEjercicio}`);
    return response.data;
  }

  public static async save(config: ConfiguracionCuenta): Promise<ConfiguracionCuenta> {
    const response = await http.post(ENDPOINTS.BASE, config);
    return response.data;
  }
}
